/**
 * Tooltip color definitions
 */
import { palette, createColor } from './palette.colors';

export const tooltipColors = {
  tooltipBackground: createColor(palette.gray.dark, palette.gray.placeholderText),
  tooltipText: createColor(palette.gray.white, palette.gray.white),
  text: createColor(palette.blue.onTint, palette.gray.white),
};